module.exports = __webpack_public_path__ + "static/media/Display.3e0eebec.jpg";